import DOMPurify from "dompurify";

type Props = {
  html: string;
  maxLength?: number;
};

export const createSanitizedMarkup = ({ html, maxLength = 200 }: Props) => {
  if (!html) {
    return { __html: "" };
  }

  const sanitizedHtml = DOMPurify.sanitize(html);
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedHtml, "text/html");
  let content = "";
  let length = 0;

  const walker = document.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    null
  );

  while (walker.nextNode()) {
    const node = walker.currentNode;
    const nodeText = node.nodeValue || "";
    if (length + nodeText.length > maxLength) {
      node.nodeValue = nodeText.substring(0, maxLength - length) + "...";
      // Remove all nodes beyond this point
      while (node.nextSibling) {
        node.parentNode?.removeChild(node.nextSibling);
      }
      // Break the outer while loop
      break;
    }
    length += nodeText.length;
  }

  // Serialize the DOM back to a string
  content = doc.body.innerHTML;

  return { __html: content };
};
